import { render, staticRenderFns } from "./EnterTerminationView.vue?vue&type=template&id=194645fd&scoped=true"
import script from "./EnterTerminationView.vue?vue&type=script&lang=js"
export * from "./EnterTerminationView.vue?vue&type=script&lang=js"
import style0 from "./EnterTerminationView.vue?vue&type=style&index=0&id=194645fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194645fd",
  null
  
)

export default component.exports